/*jshint esversion: 6 */
import React from "react";
import Select from "react-select";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Constants from "../../../configurations/constants";
import SettlementsApi from "../../../api/SettlementsApi";
import SettlementRequestsTable from "./settlementRequestsTable";
import SettlementRequestModal from "./settlementRequestModal";
import FloatInput from "../../common/floatInput";
import "./../settlement.css";

class SettlementRequestPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      settlementRequests: [],
      logCode: "",
      statuses: [],
      status: null,
      totalCount: 0,
      loading: false,
      performingAction: false,
      filterParams: {},
      pages: 0,
      openModalFlag: false,
      createFlag: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0, //Zero based index,
      selectedSettlementRequest: null,
      settlements: null
    };
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowButtonClick = this.onRowButtonClick.bind(this);
    this.onNewButtonClick = this.onNewButtonClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onDisputeRowClick = this.onDisputeRowClick.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.paginateid = this.paginateid.bind(this);
  }

  componentDidMount() {
    //Get Status
    SettlementsApi.getSettlementRequestStatuses()
      .then(response => {
        let statuses = response.data.map(status => ({
          label: status,
          value: status
        }));
        this.setState({
          statuses
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_SETTLEMENT_REQUEST_STATUSES}`
        ]);
      });

    //Load data on mount
    //this.reloadSettlements(); Already triggered  on table change
  }

  onNewButtonClick(evt) {
    this.setState({ openModalFlag: true, createFlag: true });
  }

  onSearchHandler() {
    const params = {};
    //Trigger the call here to be fired
    let status = this.state.status;
    let logCode = this.state.logCode;

    if (logCode) {
      params.logCode = logCode;
    }
    if (status && status.value) {
      params.status = status.value;
    }
    params.pageSize = this.state.pageSize;
    params.pageNum = this.state.pageNum;
    this.loadSettlements(params, true);
  }

  handleFilterChange(evt) {
    this.setState({
      status: evt,
      pageNum: 0 // Reset Pagination when category is changed
    });
  }

  paginateid(index, fullIndex) {
    if (fullIndex !== undefined) {
      return (fullIndex + 1).toString();
    }
    const offset = parseInt(this.state.pageNum, 0);
    // const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  onTextInputChange(event) {
    let stateUpdate = {};
    stateUpdate[event.target.id] = event.target.value;
    this.setState(stateUpdate);
  }

  onDisputeRowClick(index) {
    //Set the Modal to be displayed
    this.setState({ loading: true });
    const settlementRequest = this.state.settlementRequests[index];
    return this.getSettlementDetails(settlementRequest.requestReference)
      .then(response => {
        let data = response.data.request;
        let settlements = response.data.settlements;
        data = {
          ...data,
          createdOn: Util.toUserLocalTime(data.createdOn),
          lastUpdatedOn: Util.toUserLocalTime(data.lastUpdatedOn),
          settlementDate: Util.toUserLocalTime(data.settlementDate)
        };
        settlements = settlements.map(d => {
          return {
            ...d,
            settlementDate: Util.toUserLocalTime(d.settlementDate)
          };
        });
        this.setState({
          selectedSettlementRequest: data,
          settlements
        });

        this.setState({
          loading: false,
          openModalFlag: true
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_SETTLEMENT_REQUEST_STATUSES}`
        ]);

        this.setState({
          loading: false
        });
      });
  }

  render() {
    return (
      <div>
        <form
          onSubmit={e => {
            this.onSearchHandler();
            e.preventDefault();
            return false;
          }}
        >
          <div id="page-breadcrumb" className="breadcrumb-container">
            <Breadcrumbs
              separator={Constants.BREADCRUMB_SEPARATOR}
              routes={this.props.routes}
              params={this.props.params}
            />
          </div>
          <PageTitle title="Settlement Processing Requests" />
          <Divider />
          <div className="row">
            <div className="col-sm-3">
              <div className="form-group">
                <label className="input-control-label">Status</label>
                <Select
                  placeholder="Status"
                  onChange={this.handleFilterChange}
                  options={this.state.statuses}
                  value={this.state.status}
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label className="input-control-label">Log Code</label>
                <FloatInput
                  id="logCode"
                  value={this.state.logCode}
                  onChange={this.onTextInputChange}
                  placeholder="Log Code"
                />
              </div>
            </div>
            <div className="col-sm-2">
              <div className="form-group">
                <label className="mb-0" style={{ display: "block" }}>
                  &nbsp;
                </label>
                <button
                  id="searchButton"
                  className="btn btn-primary"
                  type="submit"
                  disabled={this.state.disabled}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </form>
        <SettlementRequestsTable
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          onRowClick={this.onDisputeRowClick}
          disableActions={this.state.performingAction}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          settlementRequests={this.state.settlementRequests}
          paginatedCallback={this.paginateid}
        />

        {this.state.openModalFlag && (
          <SettlementRequestModal
            isNew={this.state.createFlag}
            isOpen={this.state.openModalFlag}
            onRequestClose={this.handleCloseModal}
            requestReference={
              this.state.selectedSettlementRequest.requestReference
            }
            settlementdata={this.state.selectedSettlementRequest}
            settlements={this.state.settlements}
            paginatedCallback={this.paginateid}
          />
        )}
      </div>
    );
  }

  handleCloseModal(event, reloadDataFlag) {
    this.setState({ selectedSettlementRequest: null, openModalFlag: false });
    if (reloadDataFlag) {
      this.reloadSettlements();
    }
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadSettlements(params);
    }
  }

  loadSettlements(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true, settlementRequests: [] };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    let status = this.state.status;
    let logCode = this.state.logCode;

    if (logCode) {
      params.logCode = logCode;
    }
    if (status && status.value) {
      params.status = status.value;
    }
    SettlementsApi.getSettlementRequests(params)
      .then(response => {
        let data = response.data.content;
        data = data.map(d => {
          return {
            ...d,
            createdOn: Util.toUserLocalTime(d.createdOn),
            lastUpdatedOn: Util.toUserLocalTime(d.lastUpdatedOn),
            settlementDate: Util.toUserLocalTime(d.settlementDate)
          };
        });
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Settlement Processing Request");
        else {
          //add click handler to each data object
          data = data.map(val => {
            val.clickHandler = this.onRowButtonClick;
            return val;
          });
        }
        this.setState({
          settlementRequests: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_SETTLEMENT_REQUESTS}`
        ]);
        this.setState({ loading: false });
      });
  }

  onRowButtonClick(index, action) {
    let selectedSettlementRequest = this.state.settlementRequests[index];
    if (action !== Constants.SETTLEMENT_REQUEST_ACTION_CANCEL) {
      this.processRequest(selectedSettlementRequest.requestReference, {
        action
      });
    } else {
      this.setState({
        selectedSettlementRequest,
        openModalFlag: true,
        createFlag: false
      });
    }
  }

  reloadSettlements() {
    this.setState({ settlementRequests: [] });
    this.loadSettlements({ pageSize: this.state.pageSize });
  }

  getSettlementDetails(requestReference) {
    return SettlementsApi.getSingleSettlementRequest(requestReference);
  }

  processRequest(reference, data) {
    this.setState({ performingAction: true });
    SettlementsApi.processSettlementRequest(reference, data)
      .then(response => {
        let message = "";

        if (data.action === Constants.SETTLEMENT_REQUEST_ACTION_PROCESS)
          message = Messages.SUCCESS_SETTLEMENT_REQUEST_PROCESSED;
        if (data.action === Constants.SETTLEMENT_REQUEST_ACTION_MAP)
          message = Messages.SUCCESS_SETTLEMENT_REQUEST_MAPPED;
        if (data.action === Constants.SETTLEMENT_REQUEST_ACTION_CANCEL)
          message = Messages.SUCCESS_SETTLEMENT_REQUEST_CANCELED;

        Toaster.success(`${message}`, `${reference}`);
        this.reloadSettlements();
        this.setState({ performingAction: false });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${error.statusText}`]);
        this.setState({ performingAction: false });
      });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(SettlementRequestPage, [Permissions.VIEW_SETTLEMENT_REQUEST])
);



// WEBPACK FOOTER //
// ./src/components/settlement/settlementRequests/settlementRequestsPage.js